<template>
  <nuttrema-layout-content>

    <template slot="header">
      <team-member-standard-header
        :meta="meta"
        :showEdit="true"
        :edit.sync="edit"
        :TeamMemberDetails="TeamMemberDetails">
        <template slot="edit">
          <div class="content-header-item">
            <permissions-control-wrapper
               action="label.edit"
              :required-general="$PERMISSIONS_GENERAL.DELETE"
              :permissions="_get(TeamMemberDetails, 'meta.permissions')">
              <el-button
                 slot="allowed"
                 size="mini"
                :type="buttonType"
                @click="edit = !edit">
                {{ $t('label.edit') }}
              </el-button>

              <el-button
                slot="not-allowed"
                size="mini"
                type="info"
                class="is-icon-mr-075">
                <i class="far fa-lock-alt"></i>{{ $t('label.edit') }}
              </el-button>
            </permissions-control-wrapper>
          </div>
        </template>
      </team-member-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="TeamMemberDetails.fetching || TeamMemberStatistics.fetching"></nuttrema-loader>
      <form-person-delete
         v-else
        :id="id"
        :edit.sync="edit"
        :TeamMemberDetails="TeamMemberDetails"
        :TeamMemberStatistics="TeamMemberStatistics"
        @delete="onDelete">
      </form-person-delete>
    </template>

  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';

import TeamMemberStandardHeader from 'components/pages/professional/persons/my-team/shared/blocks/cmpt-team-member-standard-header';
import PagePersonDelete from 'components/pages/professional/persons/shared/delete/page-person-delete';

import FormPersonDelete from './form-team-member-delete';

export default {
  name: 'page-team-member-delete',
  mixins: [PagePersonDelete],
  components: {
    FormPersonDelete,
    TeamMemberStandardHeader,
  },
  computed: {
    buttonType() {
      return this.edit ? 'nuttrema-orange' : '';
    },
    TeamMemberDetails() {
      return this.$store.getters.TeamMemberDetails(this.id);
    },
    TeamMemberStatistics() {
      return this.$store.getters.TeamMemberStatistics(this.id);
    },
  },
  methods: {
    ...mapActions({
      DeletePerson: 'DeleteTeamMember',
    }),
  },
  created() {
    this.$store.dispatch('GetTeamMemberStatistics', { id: this.id });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearTeamMemberStatistics', { id: this.id });
    this.$store.dispatch('SetNeutralStateTeamMemberDetails', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/my-team/delete/page-team-member-delete.vue